export default "__VITE_ASSET__CNDJ1NfE__"